export default "__VITE_ASSET__Mt97a4mn__"